/**
 * Novigran FSE Theme Scripts
 * Main entry point - imports and initializes all modules
 */

import initScrollWatcher from './modules/scroll-watcher.js';
import initMobileMenu from './modules/mobile-menu.js';
import initFavorites from './modules/favorites.js';
import initCookieHandler from './modules/cookie-handler.js';
import initVideoFormatLoader from './modules/video-format-loader.js';
import initVideoViewportController from './modules/video-viewport-controller.js';
import initFloatingFormButton from './modules/floating-form-button.js';
import initLinkSynchronizer from './modules/link-synchronizer.js';
import initVideoLinkOverlay from './modules/video-link-overlay.js';

/**
 * Initialize all theme functionality
 */
document.addEventListener('DOMContentLoaded', function() {
    // Initialize scroll watcher
    initScrollWatcher();
    
    // Initialize mobile menu
    initMobileMenu();
    
    // Initialize favorites handler
    initFavorites();
    
    // Initialize cookie handler
    initCookieHandler();
    
    // Initialize video format loader
    initVideoFormatLoader();
    
    // Initialize video viewport controller
    initVideoViewportController();
    
    // Initialize floating form button
    initFloatingFormButton();
    
    // Initialize link synchronizer for block layouts
    initLinkSynchronizer();
    
    // Initialize video link overlay for promotional videos
    initVideoLinkOverlay();
});

